import * as React from "react";
import Icon from "@material-ui/core/Icon/Icon";
import { ClipLoader } from "react-spinners";

interface IProps {
  btnStyle: string;
  textStyles?: string;
  iconWrapperStyles?: string;
  name?: string;
  icon: string;
  isLoading?: boolean;
  disabled?: boolean;
  loaderColor?: string;
  onClick: React.EventHandler<React.MouseEvent>;
}

export class ButtonWithIcon extends React.Component<IProps> {
  public render() {
    const {
      btnStyle,
      icon,
      name,
      textStyles,
      onClick,
      iconWrapperStyles,
      isLoading,
      disabled,
      loaderColor = "#41126c",
    } = this.props;
    const iconOrSpinner = isLoading ? (
      <ClipLoader sizeUnit={"px"} size={16} color={loaderColor} loading={true} />
    ) : (
      <Icon>{icon}</Icon>
    );
    return (
      <button
        onClick={onClick}
        disabled={disabled || isLoading}
        className={btnStyle}
      >
        {iconWrapperStyles ? (
          <div className={iconWrapperStyles}>{iconOrSpinner}</div>
        ) : (
          iconOrSpinner
        )}
        <p className={textStyles}>{name}</p>
      </button>
    );
  }
}
